export const YES = 'yes';
export const NO = 'no';
